import React, {useEffect} from "react";

function Loading(props){
    useEffect(()=>{

    });
    return (
        <div className='fixed w-full h-screen bg-white top-0 left-0 z-40 flex flex-col justify-center items-center'>
          <span className="material-icons animate-spin text-[3rem] text-gray-800">
            sync
          </span>
        </div>
    )
}

export default Loading;